module.exports = __webpack_public_path__ + "img/av100.b40bbe26.png";